import React, {useEffect, useState} from 'react';
import {FlatList, StyleSheet, View, Platform} from 'react-native';
import {useSelector} from 'react-redux';
import {
   appBackground,
   isMobileWeb,
   isWeb,
   isWindows,
   isiOS,
   white,
} from '../../utils/utils';
import {CourseListItem} from './course_list_item';
import {
   selectLandscapeSmallWebView,
   selectScreenOrientation,
} from '../../redux/slices/ScreenOrientationSlice';
import logger from '../../utils/logger';

const containerLeftMargin = isWindows ? 6 : Platform.OS === 'macos' ? 10 : 16;
const containerRightMargin = isWindows ? 0 : Platform.OS === 'macos' ? 0 : 16;

export const CourseList = props => {
   const isLandscapeMode = useSelector(selectScreenOrientation);
   const [numOfCols, setNumOfCols] = useState(
      isLandscapeMode
         ? Platform.OS === 'web' ||
           Platform.OS === 'macos' ||
           Platform.OS === 'windows'
            ? 3
            : 2
         : 1,
   );
   const courseList = props.courseListData;
   const isLandscapeSmallWebView = useSelector(selectLandscapeSmallWebView);
   const [courseNameId, setCourseNameId] = useState('');
   useEffect(() => {
      setNumOfCols(
         isLandscapeMode
            ? Platform.OS === 'web' ||
              Platform.OS === 'macos' ||
              Platform.OS === 'windows'
               ? 3
               : 2
            : 1,
      );
   }, [isLandscapeMode]);

   return (
      <View
         style={[
            Platform.OS === 'web' && isLandscapeMode
               ? styles.web
               : styles.container,
            {
               maxHeight:
                  Platform.OS === 'web'
                     ? isLandscapeSmallWebView
                        ? '100vw'
                        : '100%'
                     : null,
            },
            {
               //marginTop: isLandscapeMode && !isWeb ? 8 : null,
               marginTop: isWindows ? 8 : 16,
               //marginBottom: isMobileWeb ? null : 16,
               marginHorizontal: isLandscapeMode ? null : 16,
               ...Platform.select({
                  web: {
                     marginTop: isLandscapeMode ? 8 : 8,
                  },
                  android: {
                     marginTop: isLandscapeMode ? 16 : 8,
                     marginEnd: 9,
                     marginLeft: 9,
                     marginBottom: isLandscapeMode ? null : 5,
                  },
                  ios: {
                     marginTop: isLandscapeMode ? 16 : 8,
                     marginEnd: 9,
                     marginLeft: 9,
                     marginBottom: isLandscapeMode ? null : 15,
                  },
                  windows: {
                     marginLeft: 12,
                     paddingRight: null,
                     //backgroundColor: 'red',
                     marginTop: 8,
                     marginBottom: null,
                  },
                  macos: {
                     marginTop: 8,
                     marginLeft: 8,
                  },
               }),
            },
         ]}>
         <FlatList
            // contentContainerStyle={{
            //    justifyContent: 'space-between',
            //    flexGrow: 1,
            // }}
            style={{
               paddingRight: isWindows || Platform.OS === 'macos' ? 10 : null,
               paddingBottom: Platform.OS === 'android' ? 8 : 8,
               // paddingBottom: isLandscapeMode ? 16 : null,
               ...Platform.select({
                  web: {
                     paddingBottom: isLandscapeMode ? 10 : 8,
                     paddingRight: isLandscapeMode ? 10 : null,
                  },
                  macos: {
                     marginBottom: null,
                  },
                  windows: {
                     marginBottom: null,
                     paddingBottom: isLandscapeMode ? 116 : null,
                  },
               }),
            }}
            key={numOfCols}
            removeClippedSubviews={Platform.OS == 'macos' ? false : true}
            data={courseList}
            renderItem={({item, index}) => {
               return (
                  <CourseListItem
                     item={item}
                     onItemClick={element => {
                        try {
                           props.onSingleItemClick(element);
                        } catch (e) {
                           logger(e);
                        }
                     }}
                     courseNameId={courseNameId}
                     setCourseNameId={setCourseNameId}
                     numOfCols={numOfCols}
                     index={index}
                     num={courseList?.length}
                     emptyCard={
                        courseList?.length % numOfCols > 0
                           ? numOfCols - (courseList?.length % numOfCols)
                           : 0
                     }
                  />
               );
            }}
            numColumns={numOfCols}
            keyExtractor={item => item.pid}
         />
      </View>
   );
};
const styles = StyleSheet.create({
   container: {
      flex: 1,
      marginTop: 8,
      justifyContent: 'center',
      /* marginLeft: containerLeftMargin,
      marginEnd: containerRightMargin, */
      backgroundColor: white,
      ...Platform.select({
         web: {
            paddingBottom: null,
         },
      }),
   },
   web: {
      justifyContent: 'center',
      paddingLeft: 12,
      //paddingRight: 12,
      marginLeft: 0,
      marginEnd: 0,
      backgroundColor: white,
   },
});
